import * as yup from "yup";

export const forgotPasswordSchema = yup.object({
  email: yup
    .string()
    .email()
    .required("Invalid email address. Please enter a valid email address."),
});
